export const PRODUCTIVIDAD = {
    PCRELOJ: {
        GetEmployeeCalendarView: 'EmployeeSigningService.svc/GetEmployeeCalendarView',
        GetEmployeeCalendarPausedView: 'Services/General/EmployeeSigningService.svc/GetEmployeeCalendarPausedView',
        GetEmployeeSigningById: 'Services/General/EmployeeSigningService.svc/GetEmployeeSigningById',
        FindWithTotals: 'EmployeeSigningService.svc/FindWithTotals',
        FindHourTypes: 'HourTypeService.svc/FindHourTypes',
        AddOverlay: 'EmployeeSigningService.svc/AddOverlay',
        Add: 'EmployeeSigningService.svc/AddEmployeeSigning ',
        UpdateOverlay: 'EmployeeSigningService.svc/UpdateOverlay',
        UpdateOverlayPaused: 'Services/General/EmployeeSigningService.svc/UpdateOverlayPaused',
        Update: 'EmployeeSigningService.svc/UpdateEmployeeSigning',
        GetProductivity: 'RepairOrderService.svc/GetProductivity',
        DeleteOverlay: 'EmployeeSigningService.svc/DeleteEmployeeSigning',
        DeleteEmployeeSigningById: 'EmployeeSigningService.svc/DeleteEmployeeSigningById',
    },
    GESTION_EMPLEADOS: {
        GetAll: 'Services/General/EmployeeService.svc/GetAll',
        UpdateEmployee: 'Services/General/EmployeeService.svc/UpdateEmployee',
        ComboSeccionTrabajo: 'Services/Workshop/WorkingSectionService.svc/GetAll',
        GetAllEmployeeCategories: 'Services/General/EmployeeCategoryService.svc/GetAllEmployeeCategories',
        AddEmployee:"Services/General/EmployeeService.svc/AddEmployee"
    },
    MANTENIMIENTO:{
        CATEGORIAS_EMPLEADOS:{
            GetAll: 'Services/General/EmployeeCategoryService.svc/GetAll',
        },
        PERSONAL_ALMACEN:{
            GetAll: 'Services/WareHouse/ReceptionistService.svc/GetAll',
            UpdateCategory:'Services/WareHouse/ReceptionistService.svc/Update',
            AddCategory:'Services/WareHouse/ReceptionistService.svc/Add',
            Deletecategory:'Services/WareHouse/ReceptionistService.svc/Delete',
            GetCategories:'Services/General/EmployeeCategoryService.svc/GetAllEmployeeCategories'
        }
    }
}
